import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

/**
 * This JE indicates whether or not the patient is under TLS
 */
export default class TlsActiveJournalEvent extends JournalEvent {
  static override type = "tls-active-journal-event";

  @attr("boolean", {
    allowNull: true
  })
  declare value: boolean;

  @attr("string") declare reason: string;

  @attr("date") declare reasonEventOn: Date;

  static override validations(intl: IntlService) {
    return {
      value: validatePresence({
        presence: true,
        description: intl.t("validations.tls-active-journal-event.value")
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.tls-active-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "tlsActiveJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "tls-active-journal-event": TlsActiveJournalEvent;
  }
}
